/** Remove legacy cache-first SW so CSS/JS always come from the network. */
export async function clearLegacyServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }

    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  } catch (error) {
    console.warn('[App] Service worker cleanup failed:', error);
  }
}
